import { Col, Form, Input, Row, Select, Typography } from "antd";
import QuillEditor from "components/Editor";
import FormInput from "components/FormInput";
import { INPUT_TYPE } from "config/constants";
import UploadBannerButton from "features/Campaign/components/UploadBannerButton";
import Card from "features/Cart/components/Card";
import { t } from "i18next";
import { useState } from "react";
import "./index.scss";

const LINK_TYPE_OPTIONS = [
  { value: "LANDING_PAGE", label: "Link Landing page" },
  { value: "PROMOTION_PRODUCT", label: "Link sản phẩm" },
  { value: "PROMOTION_DETAIL", label: "Link chi tiết CTKM" },
];

function MarketingInfo({ form }) {
  const [linkType, setLinkType] = useState("LANDING_PAGE");

  const onEditorChange = (value) => {
    const descriptionString = value;
    form.setFieldsValue({ description: descriptionString });
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const handleLinkTypeChange = (value) => {
    setLinkType(value);
    if (value !== "LANDING_PAGE") {
      form.setFieldsValue({ link: undefined });
      form.setFields([{ name: "link", errors: [] }]);
    }
  };

  const marketingInfoFields = {
    banner: {
      formItemOptions: {
        label: <Typography.Text strong>{t("campaign.form.bannerDesktop")}</Typography.Text>,
        name: "bannerDesktop",
        getValueFromEvent: normFile,
        rules: [
          {
            required: true,
            message: t("common.messageRequiredType", {
              message: t("campaign.form.bannerDesktop"),
            }),
          },
        ],
      },
    },
    bannerMobile: {
      formItemOptions: {
        label: <Typography.Text strong>{t("campaign.form.bannerMobile")}</Typography.Text>,
        name: "bannerMobile",
        getValueFromEvent: normFile,
        rules: [
          {
            required: true,
            message: t("common.messageRequiredType", {
              message: t("campaign.form.campaignBannerRez"),
            }),
          },
        ],
      },
    },
    link: {
      formItemOptions: {
        label: <Typography.Text strong>Link url của banner</Typography.Text>,
        name: "link",
        rules: [
          {
            validator: (_, value) => {
              if (linkType !== "LANDING_PAGE") {
                return Promise.resolve();
              }
              if (!value) {
                return Promise.reject(new Error(t("campaign.form.incorrectFormat")));
              }
              const urlPattern = /https?:\/\/[^\s/$.?#].[^\s]*/g;
              if (!urlPattern.test(value)) {
                return Promise.reject(new Error(t("campaign.form.incorrectFormat")));
              }
              return Promise.resolve();
            },
          },
        ],
      },
    },
    linkType: {
      formItemOptions: {
        name: "linkType",
        initialValue: "LANDING_PAGE",
      },
    },
    highlight: {
      type: INPUT_TYPE.TEXT_AREA,
      formItemOptions: {
        label: <Typography.Text strong>Mô tả ngắn</Typography.Text>,
        name: "highlight",
        rules: [
          {
            required: true,
            message: t("common.messageRequiredType", { message: t("campaign.form.highlight") }),
          },
          { max: 300, message: t("campaign.form.descriptionOutOfLimit") },
        ],
      },
      inputOptions: {
        placeholder: t("campaign.form.highlightPlaceholder"),
        rows: 3,
      },
    },
    description: {
      formItemOptions: {
        label: <Typography.Text strong>Chi tiết thể lệ</Typography.Text>,
        name: "description",
      },
      inputOptions: {
        onEditorChange: onEditorChange,
      },
    },
  };

  const { banner, description, link, linkType: linkTypeField, highlight, bannerMobile } = marketingInfoFields;

  return (
    <Card
      className="campaign-marketing-info"
      styles={{ height: "100%" }}
      title={<Typography.Title level={5}>{t("campaign.form.marketingInfo")}</Typography.Title>}
    >
      <Row gutter={16} className="marketing-info-content">
        <Col span={12} className="marketing-info-left">
          <Form.Item
            label={<Typography.Text strong>Link url của banner</Typography.Text>}
            required={linkType === "LANDING_PAGE"}
            style={{ marginBottom: 24 }}
          >
            <div style={{ display: "flex", gap: 12 }}>
              <div>
                <Form.Item {...linkTypeField.formItemOptions} noStyle>
                  <Select options={LINK_TYPE_OPTIONS} onChange={handleLinkTypeChange} />
                </Form.Item>
              </div>
              <Form.Item {...link.formItemOptions} label={null} noStyle>
                <Input placeholder="Nhập link landing page được tạo" disabled={linkType !== "LANDING_PAGE"} />
              </Form.Item>
            </div>
          </Form.Item>
          <FormInput {...highlight} />
          <Form.Item className="custom-markdown" {...description.formItemOptions}>
            <QuillEditor {...description.inputOptions} canUpdateInfo={false} />
          </Form.Item>
          <div className="marketing-info-spacer" aria-hidden="true" />
        </Col>
        <Col span={12} className="marketing-info-right">
          <div className="marketing-info-banners">
            <Form.Item className="banner-upload-item banner-desktop-upload" {...banner.formItemOptions}>
              <UploadBannerButton />
            </Form.Item>
            <Form.Item className="banner-upload-item banner-mobile-upload" {...bannerMobile.formItemOptions}>
              <UploadBannerButton />
            </Form.Item>
          </div>
        </Col>
      </Row>
    </Card>
  );
}

export default MarketingInfo;
